import apiRoutes from "../../utils/constants/apiRoutes";
import ApiService from "../apiService";
import handleApiCall from "../handleApi";

export const learnerStatisticsService = async (query?: any) =>
  handleApiCall(() =>
    ApiService.get(
      !query
        ? apiRoutes.learnerStatistics
        : apiRoutes.learnerStatisticsById.replace("query", query)
    )
  );
